export default import.meta.ROLLDOWN_FILE_URL_1qthAATFqLq4toQxxIy80Q